import React from "react";
import { cn } from "@/lib/utils";

interface DescriptionItemProps {
  label: string;
  span?: number;
  children: React.ReactNode;
}

interface DescriptionListProps {
  children: React.ReactNode;
  columns?: number;
  bordered?: boolean;
  className?: string;
}

export const DescriptionItem: React.FC<DescriptionItemProps> = ({ label, children }) => (
  <div className="space-y-1">
    <dt className="text-sm font-medium text-muted-foreground">{label}</dt>
    <dd className="text-sm">{children ?? "N/A"}</dd>
  </div>
);

export const DescriptionList: React.FC<DescriptionListProps> = ({
  children,
  columns = 2,
  bordered,
  className,
}) => (
  <dl
    className={cn(
      "grid gap-4",
      columns === 1 && "grid-cols-1",
      columns === 2 && "grid-cols-1 sm:grid-cols-2",
      columns === 3 && "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
      columns === 4 && "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4",
      bordered && "border rounded-lg p-4",
      className
    )}
  >
    {children}
  </dl>
);
